import { paymentType } from '@transfeeradev/api-enums';

export const paymentMethodDescriptions = {
  [paymentType.PIX]: { title: 'Limite Pix', logoUrl: '/assets/img/pix.svg' },
  [paymentType.TEV]: { title: 'Limite entre contas', logoUrl: '/assets/img/transfeera-bridge.svg' },
  [paymentType.TED]: { title: 'Limite TED', logoUrl: '/assets/img/bank-account-balance.svg' },
  [paymentType.BILLET]: { title: 'Limite Boleto', logoUrl: '/assets/img/receipt-solid.svg' }
};
